module.exports = __webpack_public_path__ + "img/Platform-section-intelligence-image-03-min-768x508.226608da.webp";